import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    UrlTree
} from '@angular/router';
import { SitesService } from '@shared/services/sites.service';
import {map, Observable} from 'rxjs';
import {BrowserProviderService} from "@shared/services/browser-provider.service";

@Injectable({
    providedIn: 'root'
})
export class HasSitesGuard implements CanActivate, CanActivateChild {
    constructor(private siteService: SitesService, private browserService: BrowserProviderService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.redirectIfNoSites();
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.redirectIfNoSites();
    }

    redirectIfNoSites(): Observable<boolean | UrlTree> {
        return this.siteService.GetSites().pipe(
            map(sites => {
                if (sites.length === 0) {
                    this.browserService.location.assign('/#/no-sites');

                    return false;
                }

                return true;
            })
        );
    }
}
